export default "__VITE_PUBLIC_ASSET__a47d5714__"